import type { ReactNode } from 'react';

/** Superficie base: cartao com borda de 1px, canto de painel e sombra leve. */
export function Painel({
  titulo,
  acoes,
  children,
  className = '',
  corpo = 'p-4',
  id,
}: {
  titulo?: ReactNode;
  acoes?: ReactNode;
  children: ReactNode;
  className?: string;
  /** Espacamento interno do corpo; 'p-0' para tabelas encostarem na borda. */
  corpo?: string;
  id?: string;
}) {
  return (
    <section id={id} className={`rounded-(--radius-painel) border border-borda bg-superficie shadow-cartao ${className}`}>
      {(titulo || acoes) && (
        <header className="flex min-h-12 flex-wrap items-center justify-between gap-x-4 gap-y-1 border-b border-borda px-4 py-2 sm:px-5">
          {titulo && <h2 className="text-[15px] font-semibold text-texto">{titulo}</h2>}
          {acoes && <div className="flex flex-wrap items-center gap-2">{acoes}</div>}
        </header>
      )}
      <div className={corpo}>{children}</div>
    </section>
  );
}

/** Titulo de secao solto (fora de painel), com acoes a direita. */
export function TituloSecao({ children, extra, id }: { children: ReactNode; extra?: ReactNode; id?: string }) {
  return (
    <div className="mb-3 flex flex-wrap items-end justify-between gap-x-4 gap-y-2 border-b border-borda pb-2">
      <h2 id={id} className="font-serif text-xl font-semibold text-marca">
        {children}
      </h2>
      {extra}
    </div>
  );
}

/** Par rotulo/valor numa grade de definicoes. */
export function Dado({ rotulo, children }: { rotulo: string; children: ReactNode }) {
  return (
    <div className="min-w-0">
      <dt className="text-xs text-apagado">{rotulo}</dt>
      <dd className="truncate font-medium">{children}</dd>
    </div>
  );
}
